import "./categories.css";
import Icono1 from "../../assets/Icono1.png";
import Icono2 from "../../assets/Icono2.png";
import Icono3 from "../../assets/Icono3.png";
import Icono4 from "../../assets/Icono4.png";
import Icono5 from "../../assets/Icono5.png";
import { useMediaQuery } from 'react-responsive';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { sliderResponsive } from "../../shared/sliderConfig";

const dataCategory = [
  {
    id: 1,
    icon: Icono1,
    titletop: "Alimentos",
    titlebottom: "y Snacks",
  },
  {
    id: 2,
    icon: Icono2,
    titletop: "Accesorios",
    titlebottom:" de uso diario",
  },
  {
    id: 3,
    icon: Icono3,
    titletop: "Bebés",
    titlebottom: "y familia",
  },
  {
    id: 4,
    icon: Icono4,
    titletop: "Cuidado ",
    titlebottom: "personal",
  },
  {
    id: 5,
    icon: Icono5,
    titletop: "Bienestar",
    titlebottom: "íntimo y sexual",
  },
];

const Categories = () => {
  const isMobile = useMediaQuery({ maxWidth: 1250 });

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : 5,
    slidesToScroll: isMobile ? 2 : 5,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 2500,
    responsive: sliderResponsive,
  };
  
  return (
    <div className="categories">
      {isMobile ? (
        <Slider {...settings} className="categories-slider">
          {dataCategory.map((category) => (
            <div key={category.id} className="category-card">
              <img src={category.icon} alt={category.title} />
              <div className="category-title">
                <p className="mb-0">{category.titletop}</p>
                <p className="mb-0">{category.titlebottom}</p>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <div className="categories-container">
          {dataCategory.map((category) => (
            <div key={category.id} className="category-card">
              <img src={category.icon} alt={category.title} />
              <div className="category-title">
                <p className="mb-0">{category.titletop}</p>
                <p className="mb-0">{category.titlebottom}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Categories;
